import * as LoginType from "../../actiontype/LoginType/LoginType";
import {getByIdUser} from '../AdminPPAction/AdminPP.jsx'
import { post,put } from "../../../../common/utils/index.js";
import { useTranslation } from 'react-i18next';
import { RESETPWDDATA } from "../../actiontype/CommonType/CommonType";
import { onCommonReducerResetPswd } from "../../actioncreator/CommonAction/Common";
// import useValidation from '../../../../common/translation';

export const createLogin= (payload,headers,navigate,setResErrorFlag,showLoader,hideLoader) => (dispatch) => {
    // const navigate = useNavigate();
    showLoader();
    dispatch({ type: LoginType.LOGIN_REQUEST })
    post('/Authentication/Login',payload,headers)
        .then(res => {
            // userId
            localStorage.setItem('userId',res.data.userId)
            localStorage.setItem("authenticationType",res?.data?.authenticationType)
            dispatch({ type: LoginType.LOGIN_SUCCESS, payload: res })
            hideLoader();
            if((res?.data?.isFirstAccess===true && res?.data?.isTempPassword===true) || (res?.data?.isFirstAccess===false && res?.data?.isTempPassword===true)){
            localStorage.setItem("token",JSON.stringify(res?.data?.token))
            localStorage.setItem('sideMenu',JSON.stringify(res?.data?.menuAccess))
            localStorage.setItem('roleId',res.data.roleId)
            localStorage.setItem('isSuccess',false)
            localStorage.setItem('userName',res?.data?.userName)
            localStorage.setItem('roleName',res?.data?.roleName_IT)
            localStorage.setItem('aslId',res?.data?.asl)

            navigate('/changePassword')
            // navigate("/dashboard")
            }else{
           
                navigate('/otpVerification')
            }
            // localStorage.setItem('sideMenu',JSON.stringify(res?.data?.menuAccess))
            // navigate('/dashboard')
        })
        .catch(err => {
         dispatch({ type: LoginType.LOGIN_FAILURE, payload: err?.message })
         setResErrorFlag(true)
         hideLoader();
        })
}
export const verifyOTP= (payload,headers,navigate,showLoader,hideLoader,showToast) => (dispatch) => {
    showLoader();
    dispatch({ type: LoginType.LOGIN_REQUEST })
    post('/Authentication/Verify-Login',payload,headers)
        .then(res => {
            dispatch({ type: LoginType.LOGIN_SUCCESS, payload: res })
            hideLoader();
            if((res?.data?.isFirstAccess===true && res?.data?.isTempPassword===true) || (res?.data?.isFirstAccess===false && res?.data?.isTempPassword===true)){
                navigate('/changePassword')
                localStorage.setItem("token",JSON.stringify(res?.data?.token))
                localStorage.setItem('sideMenu',JSON.stringify(res?.data?.menuAccess))
                localStorage.setItem('roleId',res.data.roleId)
                localStorage.setItem('aslId',res?.data?.asl)
                // localStorage.setItem('userName',res?.data?.userName)
                // localStorage.setItem('roleName',res?.data?.roleName)
              }
            else{
              localStorage.setItem("token",JSON.stringify(res?.data?.token))
              localStorage.setItem('aslId',res?.data?.asl)
              localStorage.setItem('sideMenu',JSON.stringify(res?.data?.menuAccess))
              localStorage.setItem('roleId',res.data.roleId)
              localStorage.setItem('isSuccess',true)
              localStorage.setItem('userName',res?.data?.userName)
              localStorage.setItem('roleName',res?.data?.roleName_IT)
              showToast('success','Successo', 'Utente loggato con successo.');
              if(res.data.roleId===1){
                navigate('/qcadmin')
              }else{
                // localStorage.removeItem("authenticationType")
                navigate('/dashboard')
              }
             
           }
        })
        .catch(err => {
         dispatch({ type: LoginType.LOGIN_FAILURE, payload: err?.message })
         showToast('error','Pericolo', 'OTP non valido');
         hideLoader();
        })
}
export const forgotPasswordCreate= (payload,navigate,showLoader,hideLoader,showToast) => (dispatch) => {

    showLoader();
    dispatch({ type: LoginType.LOGIN_REQUEST })
    post('/Authentication/ForgotPassword',payload)
        .then(res => {
            dispatch({ type: LoginType.LOGIN_SUCCESS, payload: res })
            hideLoader();
            navigate('/login')
            showToast('success','Successo', 'La Password ricevuta via mail deve essere cambiata');
            
        })
        .catch(err => {
         showToast('error','Pericolo', 'Inserisci il tuo indirizzo email registrato.');
         dispatch({ type: LoginType.LOGIN_FAILURE, payload: err?.message })
         hideLoader();
        })
}
export const sendOtp= (payload,navigate,showLoader,hideLoader,navigateFlag,setOtpSelectionFlag,setOtpCodeFlag,setTimer =()=>{}) => (dispatch) => {
    showLoader();
    dispatch({ type: LoginType.SENDOTP_REQUEST })
    post('/Master/OtpRequest',payload)
        .then(res => {
            dispatch({ type: LoginType.SENDOTP_SUCCESS, payload: res })
            // localStorage.setItem('isSuccess',true)
            hideLoader();
            setTimer(120)
            let headers={
                AccessIdentifier:'Validate' 
            }
            if(navigateFlag===true){
                navigate('/otpVerification')
            }
            // else if(userProfile==true){
            //     setOtpSelectionFlag(false)
            //     setOtpCodeFlag(true) 
            //     // setIsModalOpen(true)
            // }
            else{
                setOtpSelectionFlag(false)
                setOtpCodeFlag(true)
            }
        })
        .catch(err => {
         dispatch({ type: LoginType.SENDOTP_FAILURE, payload: err?.message })
         hideLoader();
        })
}

export const updatePassword= (payload,headers,navigate,showLoader,hideLoader,showToast,t,flag,setNotificationFlag,payloadOne,navigateFlag,changePwFirstAccess,setIsError = ()=>{},setIsOldPasswordErr = ()=>{},resetString) => (dispatch) => {
    showLoader();
    let roleData=JSON.parse(localStorage.getItem('roleId'))
    dispatch({ type: LoginType.CHANGEPASSWORD_REQUEST })
    put('/Authentication/ChangePassword',payload,headers)
        .then(res => {
            dispatch({ type: LoginType.CHNAGEPASSWORD_SUCCESS, payload: res })
            hideLoader();
            if(headers.AccessIdentifier==='validate'){
                // localStorage.setItem('isSuccess',false)
                if(resetString!="resetPassword"){
                    localStorage.setItem('isSuccess',true)  
                }
            }else if(headers.AccessIdentifier==='Verify'){
                localStorage.setItem('isSuccess',true)
            }
           
        if(flag===true){
            setNotificationFlag(true)
            // localStorage.setItem('isSuccess',true)
            localStorage.removeItem('oldPassword')
            localStorage.removeItem('password')
           }else{
            setNotificationFlag(false)
            if(changePwFirstAccess===true){
            dispatch(sendOtp(payloadOne,navigate,showLoader,hideLoader,navigateFlag))
            }else{
                if(roleData==='1'){
                    navigate('/qcadmin')
                  }else{
                    navigate('/dashboard')
                  }
                 
                localStorage.removeItem('oldPassword')
                localStorage.removeItem('password')
            }
           }
        })
        .catch(err => {

         if(err?.response?.data?.StatusCode===403){
            showToast('warn','Warning', 'OTP non valido')
         }else{
            showToast('warn','Warning', t(err?.response?.data?.message));
         }
        // 
        //  if(err?.response?.data?.message === "INVALID_OLD_PASSWORD"){
        //     setIsOldPasswordErr(true)
        //     setIsError('La tua vecchia password non corrisponde')
        //  }
         hideLoader();
         dispatch({ type: LoginType.CHANGEPASSWORD_FAILURE, payload: err?.response?.data?.message })
        })
}
